import React from 'react';
import Typography from '@mui/material/Typography';

interface ResultCountProps {
  count: number;
}

export const ResultCount: React.FC<ResultCountProps> = ({ count }) => (
  <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
    Hiển thị {count} kết quả
  </Typography>
);
